import { render, staticRenderFns } from "./FileForm18.vue?vue&type=template&id=6bdfc388&scoped=true&"
import script from "./FileForm18.vue?vue&type=script&lang=js&"
export * from "./FileForm18.vue?vue&type=script&lang=js&"
import style0 from "./FileForm18.vue?vue&type=style&index=0&id=6bdfc388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdfc388",
  null
  
)

export default component.exports